import {
    addClass,
    removeClass,
    hasClass,
    getParentByClass,
    getElementExists,
} from './../helper/helper';


/**
 * shows popup message with provided params
 * @param {String} title for popup
 * @param {String} message - content for message
 * @param {String} buttonText - text on button success
 * @param {Function} buttonHandler - callback for button success click
 */
export function showPopup(title, message, buttonText, buttonHandler) {
    const popupWrapper = document.getElementById('en-popup-wrapper');
    const popupTitle = document.getElementById('en-popup-title');
    const popupMessage = document.getElementById('en-popup-message');
    const button = document.getElementById('en-popup-button-ok');

    popupWrapper.classList.add('visible');

    popupTitle.innerText = title;
    popupMessage.innerText = message;
    button.innerText = buttonText;
    button.onclick = () => {
        if (buttonHandler) {
            buttonHandler();
        }
        popupWrapper.classList.remove('visible');
    }
}

export function hidePopup(popup) {
    // Fire custom event on closing popup
    if (popup.hasAttribute('data-custom-close-event')) {
        let customWindowEvent = new CustomEvent(
            popup.getAttribute('data-custom-close-event'),
            {
                popup: popup,
            }
        );
        window.dispatchEvent(customWindowEvent);
    }

    removeClass(popup, 'visible');
}

export default function initPopups() {
    /**
     *  click listener if click outside active row or popup
     */
    document.addEventListener('click', function (e) {
        let target = e.target;

        // cancel if datepicker was clicked
        if (
            hasClass(target, 'datepicker-dropdown') ||
            getParentByClass(target, 'datepicker-dropdown')
        ) {
            return false;
        }
        // cancel if context menu was clicked
        if (getParentByClass(target, 'en-data-context-menu')) {
            return false;
        }

        // get active popup
        let clickedPopup = null;
        if (hasClass(target, 'en-popup') && !hasClass(target, 'en-popup__inner')) {
            clickedPopup = target;
        } else if (getParentByClass(target, 'en-popup')) {
            clickedPopup = getParentByClass(target, 'en-popup');
        }

        // get all visible popups
        let visiblePopups = document.querySelectorAll(".en-popup.visible");

        // hide popup
        for (let i = 0; i < visiblePopups.length; i++) {
            // hide on click on backdrop
            if (
                hasClass(target, 'en-popup-backdrop') ||
                hasClass(target, 'en-popup-hide')
            ) {
                hidePopup(visiblePopups[i]);
                continue;
            }

            // don´t hide if current popup clicked
            if (getElementExists(clickedPopup) && clickedPopup == visiblePopups[i]) {
                continue;
            }

            // hide
            hidePopup(visiblePopups[i]);
        }
    });
}
